export const authorPathStepColors = [
  '#898989',
  '#505CFF',
  '#A84DFF',
  '#FF3DAE',
  '#A8EA3A',
] as const;

/** Шаги секции «Путь автора в Molwe». */
export const authorPathSteps = [
  {
    title: '01. Публикуешь в Molwe или отправляешь текст',
    description: 'Фанфик или ориджинал — оба формата принимаются на равных.',
    badge: null,
  },
  {
    title: '02. Проходишь отбор',
    description: 'Оцениваем текст, цели, аудиторию и потенциал автора.',
    badge: null,
  },
  {
    title: '03. Получаешь маршрут',
    description: 'Предлагаем подходящий формат без деления авторов на главных и второстепенных.',
    badge: 'ВЫБЕРИ СВОЙ УРОВЕНЬ РОСТА',
  },
  {
    title: '04. Развиваешь текст и автора',
    description: 'Упаковка, рекомендации, позиционирование и продвижение.',
    badge: null,
  },
  {
    title: '05. Выходишь в проекты',
    description: 'Подборки, сборники, медиа, фестивали и спецпроекты.',
    badge: null,
  },
] as const;
